export default {
  en: {
    working: 'Resetting…',
    done: 'Reset',
    serverError: 'Backend did not respond',
    reset: 'Reset onboarding',
  },
  ru: {
    working: 'Сбрасываю…',
    done: 'Сброшено',
    serverError: 'Бэкенд не ответил',
    reset: 'Сбросить онбординг',
  },
  de: {
    working: 'Setze zurück…',
    done: 'Zurückgesetzt',
    serverError: 'Backend hat nicht geantwortet',
    reset: 'Onboarding zurücksetzen',
  },
  pt: {
    working: 'Redefinindo…',
    done: 'Redefinido',
    serverError: 'O backend não respondeu',
    reset: 'Redefinir onboarding',
  },
  fr: {
    working: 'Réinitialisation…',
    done: 'Réinitialisé',
    serverError: 'Le backend n’a pas répondu',
    reset: 'Réinitialiser l’onboarding',
  },
  es: {
    working: 'Restableciendo…',
    done: 'Restablecido',
    serverError: 'El backend no respondió',
    reset: 'Restablecer el onboarding',
  },
};
